export default __webpack_public_path__ + "static/media/devices.c346a5b8.svg";